'use strict';

// W3C Verifiable Credential as an ES256K JWT, signed with the user's mnemonic-derived
// identity key. Thin layer over the shared JWT core (./jwt) — the VC just shapes the payload.

const jwt = require('./jwt');

/**
 * Issue a VC-JWT signed with the issuer's secp256k1 identity key (ES256K).
 * @param {object} o - { issuerDid, kid='key-1', privateKey (bsv), subjectId, type, claims, ttlSec }
 */
function issueVc({ issuerDid, kid = 'key-1', privateKey, subjectId, type = 'AuthenticContentCredential', claims = {}, ttlSec = 0 }) {
  const iat = jwt.nowSec();
  const header = { alg: 'ES256K', typ: 'JWT', kid };
  const payload = {
    iss: issuerDid,
    sub: subjectId || issuerDid,
    iat,
    vc: {
      '@context': ['https://www.w3.org/2018/credentials/v1'],
      type: ['VerifiableCredential', type],
      credentialSubject: claims,
    },
  };
  if (ttlSec > 0) payload.exp = iat + ttlSec;
  return jwt.signJwt(header, payload, privateKey);
}

const decodeVc = jwt.decodeJwt;

/** Verify a VC-JWT against a JWKS resolved from the issuer DID (ES256K + legacy ES256). */
async function verifyVc(vcJwt, jwks) {
  const r = await jwt.verifyJwt(vcJwt, jwks);
  if (!r.valid) return r;
  if (!r.payload.iss) return { valid: false, reason: 'missing issuer', header: r.header, payload: r.payload };
  return r;
}

module.exports = { issueVc, decodeVc, verifyVc, jwkFromPublicKey: jwt.jwkFromPublicKey, publicKeyFromJwk: jwt.publicKeyFromJwk };
